
export class TableHeaderActionService<T> {

	protected actionsMap: Map<T, () => void>;

	tableSelectedItems: string[] = [];

	onActionClick(action: T): void {
		this.actionsMap.get(action)();
	}
}
